<!-- Modal toggle -->
<div class="flex justify-center m-5">
  <button id="updateProductButton" data-modal-target="updateProductModal" data-modal-toggle="updateProductModal" class="block text-white bg-blue-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800" type="button">
    Erstellen
  </button>
</div>
<br>
<div class="flex justify-center m-5">
  <h1 class="text-4xl">Von mir Erstellt</h1>
</div>
<br>
<!-- Main modal -->
<div id="updateProductModal" tabindex="-1" aria-hidden="true" class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-modal md:h-full">
  <div class="relative p-4 w-full max-w-2xl h-full md:h-auto">
    <!-- Modal content -->
    <div class="relative p-4 bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5">
      <!-- Modal header -->
      <div class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 dark:border-gray-600">
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
          Erstelle eine Reason
        </h3>
        <button type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-toggle="updateProductModal">
          <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
          <span class="sr-only">Schliesen</span>
        </button>
      </div>
      <!-- Modal body -->
      <form action="#">
        <div class="grid gap-4 mb-4 sm:grid-cols-2">
          <div>
            <label for="title" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Titel</label>
            <input type="text" name="title" id="title" [formControl]="title" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" >
          </div>
          <div>
            <label for="description" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Reason</label>
            <input type="text" name="description" id="description" [formControl]="description" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" >
          </div>
          <div>
            <label for="topic" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Warum</label>
            <select id="topic" (change)="selectTopicChange($event)" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
              <option> <input type="text"/> </option>
              @for (topic of topics; track topic.id){
                <option [ngValue]="topic.id">{{topic.topicname}}</option>
              }
            </select>
          </div>
          <div>
            <label for="user" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Für</label>
            <select id="user" (change)="selectChange($event)" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
              <option>Jeder</option>
              @for (user of users; track user.id){
                <option [ngValue]="user.id">{{user.username}}</option>
              }
            </select>
          </div>
        </div>
        <div class="flex items-center space-x-4">
          <button (click)="save()" type="submit" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">
            Erstellen
          </button>
        </div>
      </form>
    </div>
  </div>
</div>


@for (item of reasons; track item.id){
  <section class="bg-white dark:bg-gray-900 xl:ml-40 xl:mr-40" (click)="openReason(item.id)">
    <div class="grid gap-8 mb-6 lg:mb-16 ">
      <div class="items-center bg-gray-50 rounded-lg shadow sm:flex dark:bg-gray-800 dark:border-gray-700">
        <div class="p-5">
          <h3 class="text-xl font-bold tracking-tight text-gray-900 dark:text-white">
            <a href="#">{{ item.title }}</a>
          </h3>
          <span class="text-gray-500 dark:text-gray-400">#{{item.topic}}</span>
          <p class="mt-3 mb-4 font-light text-gray-500 dark:text-gray-400">{{item.description}}</p>
        </div>
      </div>
    </div>
  </section>
}
